<template>
  <div>
    <div class="vehicle-card"
         v-for="vehicle in vehicles"
         :key="vehicle.id"
         v-if="([2,3,4].includes(vehicle.status))"
    >
      <v-card class="mb-2">
        <div class="col-12">
          <div class="box">
            <div class="d-flex align-items-center w-25">
              <div class="d-flex justify-end align-items-end">
                <div class="warning-time mb-2" v-if="vehicle.activation.parking_notification_id !== null">
                  <i class="fas fa-exclamation-triangle"></i>
                  <h6>Com Irregularidade</h6>
                </div>
                <div class="warning-time mb-2" v-else-if="vehicle.status === 2">
                  <i class="fas fa-car"></i>
                  <h6>Estacionado</h6>
                </div>
                <div class="warning-time mb-2" v-else-if="vehicle.status === 3">
                  <i class="fas fa-stopwatch"></i>
                  <h6>Agendado</h6>
                </div>
              </div>

              <div class="ml-5">
                <h6 :class="{'color-red':vehicle.activation.parking_notification_id !== null}">
                  <i class="fas fa-car"></i>
                  {{
                    vehicle.vehicle.vehicle_maker_model.name
                  }}
                </h6>
                <h2 :class="{'color-red':vehicle.activation.parking_notification_id !== null}">
                  {{ vehicle.plate.toUpperCase() }}</h2>
              </div>
            </div>
            <div class="box-details">
              <div class="row mb-1">
                  <span class="mx-auto">
                      {{ vehicle.activation.address }}
                  </span>
              </div>
              <div class="row">
                <span>Início</span>
                <span class="ml-auto">
                    {{ vehicle.activation.date_time_begin | timeStampToHourMin }}
                </span>
              </div>
              <div class="row">
                <span>Término</span>
                <span class="ml-auto">
                                    {{ vehicle.activation.date_time_end | timeStampToHourMin }}
                                </span>
              </div>
              <div class="row">
                <span>Duração</span>
                <span class="ml-auto">
                    {{ vehicle.activation.time }} min
                </span>
              </div>
              <div class="row">
                <span>Valor</span>
                <span class="ml-auto">
                    R$ {{ vehicle.activation.price | integerToMoney | integerToMoney2 }}
                </span>
              </div>
              <div class="row">
                <span>Status</span>
                <span class="ml-auto">
                    {{ vehicle.activation.parking_notification_id !== null ? 'Com irregularidade/' : '' }}
                    {{ vehicle.status_enum| capitalize }}
                </span>
              </div>
              <div class="row">
                <span>Tipo</span>
                <span class="ml-auto" v-if="idx(vehicle, _ => _.activation.details[0].product.category.name)">
                    {{ idx(vehicle, _ => _.activation.details[0].product.category.name) }}
                </span>
                <span class="ml-auto" v-else>
                    {{ vehicle.activation.type | activationTypeToText }}
                </span>
              </div>
            </div>
            <div class="d-block d-md-flex flex-column st justify-content-center align-items-center">
              <router-link :to="{
                name:'activation',
                params: {
                  plate: vehicle.plate
                }
              }">
                <button class="btn-green w-100">
                  <i class="fas fa-stopwatch mr-2"></i> Adicionar Tempo
                </button>
              </router-link>
              <div v-if="showLeaveParking && vehicle.activation.left_parking !== true && vehicle.activation.inside_last_fraction !== true">
                <button class="btn-cancel" @click.prevent="dialog.leaveParking = vehicle">
                  <i class="fas fa-stopwatch mr-2"></i> Sair da Vaga
                </button>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
    <leave-parking
        @dialog="closeLeaverParking()"
        :vehicle="dialog.leaveParking"
    >
    </leave-parking>
    <div class="message-data" v-show="countVehicles === 0 && loading === false">
      <i class="far fa-bell"></i>
      <span>Você não possui nenhum veículo ativo no momento.</span>
    </div>
  </div>
</template>

<script>
import LeaveParking from '../components/LeaveParking'
import axios from 'axios';
import moment from 'moment';
import idx from "idx";

export default {
  name: "ActiveVehicles",
  components: {LeaveParking},
  data: function () {
    return {
      countVehicles: 0,
      dialog: {
        leaveParking: false,
      },
      center: {
        lat: -25.0994,
        lng: -50.1583
      },
      vehicles: [],
      markers: [],
      loading: false,
    }
  },
  methods: {
    idx,
    closeLeaverParking: function () {
      this.dialog.leaveParking = false;
    },
    timeLeft: function (start, minutes) {
      const end = moment(moment(start).add(minutes, 'minute'));
      const diff = moment(end).diff(moment());
      return moment.duration(diff).hours() < 1 && moment.duration(diff).minutes() < 1 ? 0 : moment.duration(diff).minutes();
    },
  },
  mounted() {
    this.loading = true;
    axios.get('/api/users/driver/me/plate').then(({data}) => {
      this.vehicles = data.data;
      this.vehicles.forEach(vehicle => {
        if (vehicle.activation !== null) {
          if ([
            2,
            3,
            4
          ].includes(vehicle.status)) {
            this.countVehicles++;
          }
          if (this.timeLeft(vehicle.activation.date_time_begin, vehicle.activation.time) < this.minTimeFraction) {
            vehicle.activation.inside_last_fraction = true;
          }
        }
      });
      this.loading = false;
    });
  },
  computed: {
    showLeaveParking() {
      return process.env.VUE_APP_SHOW_LEAVE_PARKING;
    },
    minTimeFraction() {
      return process.env.VUE_APP_MIN_TIME_FRACTION;
    },
  }
}
</script>

<style scoped>
.box {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  /*d-flex align-items-center justify-content-between*/
}

h6 {
  font-size: 14px;
  color: #595959;
  font-family: Roboto-Light;
  margin: 0;
}

h2 {
  font-size: 26px;
  font-family: Roboto-Black;
  color: #595959;
  margin: 0 0 3px 0;
}

.progress-circular span {
  display: block;
  font-family: Roboto-Black;
  font-size: 22px;
}

h5 {
  margin-top: 5px;
  font-size: 18px;
  color: #595959;
  font-family: Roboto-Black;
}

.box-details {
  /*margin: 0 5% 0 5%;*/
  /*flex: 1;*/
  border-left: 1px dashed #e2e2e2;
  border-right: 1px dashed #e2e2e2;
  padding: 0 30px;
  font-size: 14px;
  font-family: Roboto-Bold;
  color: #595959;
  display: block;
  width: 300px;
}

.color-red {
  color: #E72C1F !important;
}

.vehicle-card:hover {
  cursor: pointer;
  background: #eeeeee;
}

.btn-red {
  text-transform: capitalize;
  background: #e72c1f;
  color: #ffffff;
  font-family: Roboto-Black;
  width: 250px;
  height: 43px;
  border-radius: 4px;
  padding: 8px 15px;
  border: 3px solid #e72c1f;
}

.btn-red:hover {
  background: transparent;
  color: #e72c1f;
}

.subtitle-content {
  font-size: 18px;
  font-family: Roboto-Bold;
  color: #595959;
  margin-bottom: 5px;
  margin-top: 30px;
}

.warning-time {
  width: 100px;
}

.warning-time h6 {
  text-transform: uppercase;
  display: block;
  font-family: Roboto-Black;
  color: #e72c1f;
  text-align: center;
  font-size: 14px;
  margin: 0;
}

.warning-time i {
  display: block;
  color: #e72c1f;
  text-align: center;
  font-size: 38px;
  margin-bottom: 5px;
}

@media only screen and (max-width: 999px) {
  .box {
    display: block;
  }

  .box-details, .btn-red {
    width: 100%;
    margin: 10px 0;
  }
}

@media only screen and (max-width: 768px) {
  .btn-cancel {
    width: 100%;
  }
}

</style>
